export default {
  "content": "<path d=\"M0 0h32v32H0z\" fill=\"none\"/><path d=\"M30.586 13.2l.005-.007-2.59-1.9V8a1 1 0 00-1-1H5a1 1 0 00-1 1v3.27l-2.628 1.923.005.007a.994.994 0 00-.415.8v16a1 1 0 001 1H30a1 1 0 001-1V14c0-.32-.16-.613-.414-.8zm-2.42.696L28 13.99v-.217l.167.123zM26 9v6.134L16 20.85l-10-5.7V9zM4 14.01l-.2-.115.2-.146v.26zM29 29H2.962V15.72l12.542 7.15a.998.998 0 00.99 0L29 15.722zM15 0h2v4h-2zm5.168 4.445l2-3 1.664 1.108-2 3zm-12-1.89l1.664-1.11 2 3-1.664 1.11z\" fill=\"#3F4450\"/>",
  "attrs": {
    "viewBox": "0 0 32 32",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};